import React, { Fragment } from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import FormField from 'src/Components/FormField'
import Input from 'src/Components/Input'
import Text from 'src/Components/Text'
import { FORM_FIELD_NAMES } from 'src/constants/affordability'
import TYPES from 'src/Components/FormField/types'
import PersistAffordabilityButton from 'src/features/buyers/Components/Global/AffordabilityModal/PersistAffordabilityButton'

import styles from './CustomPricePointTab.module.scss'

const propTypes = {
  className: PropTypes.string
}

const StyledText = ({ className, ...restProps }) => (
  <Text
    element='span'
    className={classnames(styles.text, className)}
    {...restProps}
  />
)

const StyledInput = props => <Input className={styles.input} {...props} />

const CustomPricePointTab = ({ className, onChange, value }) => (
  <Fragment>
    <FormField
      input={StyledInput}
      labelText={StyledText}
      className={styles.field}
      name={FORM_FIELD_NAMES.PRICEPOINT}
      type={TYPES.NUMBER}
      onChange={onChange}
      value={value}
      placeholder='$0'
      min='0'
      step='1'
      required
    >
      <FormattedMessage
        id='Affordability.form.pricePoint'
        defaultMessage='Enter your price point'
      />
    </FormField>
    <PersistAffordabilityButton className={styles.button} />
  </Fragment>
)

CustomPricePointTab.propTypes = propTypes

export default CustomPricePointTab
